export const getOrderNumberForSendInfoStatistics = (label) => {
  const ordersObj = {
    totalRewards: 3,
    totalAbsences: 2,
    totalVacations: 1,
  };
  return ordersObj[label];
};
